import {Col, Divider, Row, theme} from 'antd'
import React, {useEffect} from 'react'
import {useCurrentUser} from '../../hooks/useCurrentUser'
import {CalendarReminders} from '../calendarRemiders/CalendarReminders'
import {Reminders} from '../reminders/Reminders'
import './home.less'
import {Outlet, useNavigate, useNavigation, useRouteLoaderData} from 'react-router-dom'
import {ToDo} from '../../entities/todoList'
import {useIntl} from 'react-intl'

export function HomeAll() {
  const {unfinishedUserToDos = [], plantedPlantsNamesWithId = []} = useRouteLoaderData(
    'homeAll'
  ) as {
    unfinishedUserToDos: ToDo[]
    plantedPlantsNamesWithId: {id: number; name: string}[]
  }

  const user = useCurrentUser()

  const intl = useIntl()

  const {
    token: {controlHeightSM},
  } = theme.useToken()

  if (!user) {
    return null
  }

  const navigation = useNavigation()
  const navigate = useNavigate()

  return (
    <div className="home-layout">
      <Outlet />

      <div className="home-layout__calendar">
        <CalendarReminders todos={unfinishedUserToDos} />
      </div>
      <div className="home-layout__reminders">
        <Reminders
          todos={unfinishedUserToDos}
          plantedPlantsNamesWithId={plantedPlantsNamesWithId}
        ></Reminders>
      </div>
    </div>
  )
}
